import { RentalAdvert, SprocketAsset, RentalAdvertTranslation } from "../../../types/types";
import * as React from "react"
import SimpleFormat from "../../../utils/SimpleFormat";
import { SurroundingsRentalBooleans } from "../../../advert_detail/booleans";
import * as Immutable from 'immutable'
import ReadMore from "../../shared/advert/ReadMore";
import ContentMap, { ContentMapType } from "../../shared/advert/ContentMap";
import RentalBooleanList from "./RentalBooleanList";

type Props = {
  advert: RentalAdvert
  mapType: ContentMapType
  setMapType: (t: ContentMapType) => void
  mapsIcon: SprocketAsset
  googleMapsKey: string
  translation: RentalAdvertTranslation
}

export default (props: Props) : JSX.Element => (
  <>
    <div className="content-part">
      <h3>
        {I18n.t("rental_adverts.description.surroundings")}
      </h3>
      <div className="maps-wrapper">
        <div className="grid-70 tablet-grid-70 grid-parent googlemaps">
          <ContentMap
            advert={props.advert}
            mapType={props.mapType}
            setMapType={(m) => props.setMapType(m)}
            icon={props.mapsIcon}
            googleMapsKey={props.googleMapsKey}
          />
        </div>
        <div className="grid-30 tablet-grid-30 grid-parent map">
          {
            props.advert.region.area ?
              <>
                <a href={props.advert.region.area.path}>
                  <div dangerouslySetInnerHTML={{__html: props.advert.region.staticAbstractMapSvg}} />
                </a>
                <a href={props.advert.region.area.path}>{props.advert.region.name}</a>
              </>
            : <div dangerouslySetInnerHTML={{__html: props.advert.region.staticAbstractMapSvg}} />
          }
        </div>
      </div>
      {!!props.translation && props.translation.locationText ?
        <div className="location-text">
          <div className="description">
            <ReadMore height={180}>
              <SimpleFormat
                text={props.translation.locationText}
              />
              <RentalBooleanList
                advert={props.advert}
                booleans={Immutable.OrderedSet(SurroundingsRentalBooleans()).filter(x => props.advert[x]).toOrderedSet()}
              />
            </ReadMore>
          </div>
        </div>
      : <></>}
    </div>
    <hr />
  </>
)
